import { render } from "./Locate.vue?vue&type=template&id=3c1c2cb6"
import script from "./Locate.vue?vue&type=script&lang=js"
export * from "./Locate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__